 const sparkleLayer = document.getElementById('sparkleLayer');
    const container = document.getElementById('logoContainer');
    
    // Config
    const COLORS = ['#EF4444', '#DC2626', '#FF0000', '#B91C1C', '#FCA5A5'];
    
    // Heart SVG String
    const HEART_SVG = (color) => `
      <svg viewBox="0 0 24 24" fill="${color}" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
      </svg>
    `;

    // Helpers
    const random = (min, max) => Math.random() * (max - min) + min;
    const randomColor = () => COLORS[Math.floor(Math.random() * COLORS.length)];

    function createSparkle() {
      const el = document.createElement('div');
      el.classList.add('sparkle');
      
      // Randomize Physics
      const startX = random(-140, 140);
      const startY = random(-30, 30);
      const angle = random(0, 360);
      const dist = random(20, 50);
      const radian = (angle * Math.PI) / 180;
      const endX = startX + Math.cos(radian) * dist;
      const endY = startY + Math.sin(radian) * dist;
      const size = random(8, 20);
      const duration = random(2.5, 5.0);
      const delay = random(0, 0.5);
      const rotation = random(0, 360);
      const color = randomColor();

      // Apply CSS Variables
      el.style.setProperty('--sx', `${startX}px`);
      el.style.setProperty('--sy', `${startY}px`);
      el.style.setProperty('--tx', `${endX}px`);
      el.style.setProperty('--ty', `${endY}px`);
      el.style.setProperty('--rot', `${rotation}deg`);
      el.style.setProperty('--dur', `${duration}s`);
      el.style.setProperty('--delay', `${delay}s`);
      el.style.width = `${size}px`;
      el.style.height = `${size}px`;
      
      el.innerHTML = HEART_SVG(color);
      
      sparkleLayer.appendChild(el);

      // Cleanup
      setTimeout(() => {
        el.remove();
      }, (duration + delay) * 1000);
    }

    function addSparkles(count) {
      for (let i = 0; i < count; i++) {
        createSparkle();
      }
    }

    // Loop for continuous background sparkles (High Density)
    setInterval(() => {
      addSparkles(random(3, 6)); 
    }, 400);

    // Hover Effect for Burst
    container.addEventListener('mouseenter', () => {
      addSparkles(40);
    });